import axios from 'axios';
import { getPath } from '../lib/white-cache';

export const updatePreviewShopSign = async (
  shopSignId: string,
  configurationJson: any,
  customConfigurationJson: any
): Promise<boolean> => {
  try {
    const previewConfigurationJson = configurationJson;
    const previewCustomConfigurationJson = customConfigurationJson;
    // const previewConfigurationJson = JSON.stringify(configurationJson);
    // const previewCustomConfigurationJson = JSON.stringify(
    //   customConfigurationJson
    // );
    await axios.put(`${getPath()}/ShopSign/Theme/Preview`, {
      id: shopSignId,
      PreviewConfigurationJsonDynamic: previewConfigurationJson,
      PreviewCustomConfigurationJsonDynamic: previewCustomConfigurationJson,
    });
    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
};
